import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Button,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";
import useRestrictedReportsHook from "../hooks/RestrictedReportsHook";
import { useTheme } from "@mui/material/styles";

const RestrictedCourseRosterSpring = ({ schoolId, linkColor }) => {
  const { data, loading } = useRestrictedReportsHook(schoolId);

  const restricted_course_roster_spring =
    data.length > 0 ? data[0].restricted_course_roster_spring : "";

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Card>
      <CardHeader
        title="Restricted Course Roster - Spring"
        sx={{ backgroundColor: "#AC1A2F", color: "white" }}
      />
      <CardContent>
        {restricted_course_roster_spring && (
          <Button
            variant="contained"
            component="a"
            href={restricted_course_roster_spring}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              backgroundColor: "#AC1A2F",
              color: "white",
              minWidth: "auto",
              whiteSpace: "nowrap",
              "&:hover": {
                backgroundColor: "#8B0000",
              },
            }}
          >
            View Report
          </Button>
        )}
      </CardContent>
    </Card>
  );
};

export default RestrictedCourseRosterSpring;
